import "./Thankyou.css";
import Footer from "../Home/footer";
import Header from "../Home/header";
import { useState } from "react";
import { useEffect } from "react";
const Thankyou = () => {
  const [email, setemail] = useState();

  useEffect(() => {
    const email = localStorage.getItem("email");
    if (email) {
      setemail(email);
    }
  }, []);

  const handlhome = () => {
    localStorage.clear();

    window.location.href = "/";
  };

  return (
    <>
      <Header />
      <div className="site-header">
        <h1>THANK YOU!</h1>
        <i className="fa-solid fa-check"></i>
      </div>

      <div className="main-content">
        <p>Thank you for your purchase! . </p>
        <p>
          <span>
            {" "}
            Our team will start working on your order. We will send you all the
            information about your IPTV subscription via email
            <strong> {email}</strong> within 4 hours from now{" "}
          </span>{" "}
        </p>

        <p>
          We hope you enjoy your new purchase and please don't hesitate to reach
          out if you have any questions or concerns. Thank you again!
        </p>

        <div className="btngohom">
          {" "}
          <button onClick={handlhome}> Back Home</button>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Thankyou;
